import React, { useState } from "react";
import { MDBCard } from "mdb-react-ui-kit";
import EmployeeCertificateModal from "./EmployeeCertificateModal";

function EmployeeCertificates({ employeeData }) {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);

  const toggleShow = () => {
    setShow(!show);
  };

  return (
    <>
      <div>
        <h2>
          You do not have any Certificates uploaded yet. Click on the button
          below to add some.
        </h2>
        <button
          style={{
            backgroundColor: "var(--primary)",
            color: "var(--light)",
            borderRadius: "10px",
            padding: "1.5%",
            border: "none",
          }}
          onClick={toggleShow}
        >
          Add Certificate
        </button>
      </div>

      <EmployeeCertificateModal show={show} handleClose={handleClose} />
    </>
  );
}

export default EmployeeCertificates;
